export default __webpack_public_path__ + "cff806a7c5b3edb7401158f6331682a1.svg";